<template>
    <div class="letsgo-container" :style="{'height': __layoutCenterHeightCalculate.value - 20 +'px'}">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "LetsGo",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
